
    import '/opt/buildhome/repo/components/bubble/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["bubble-demo-basic","bubble-demo-avatar-and-placement","bubble-demo-header-and-footer","bubble-demo-loading","bubble-demo-typing","bubble-demo-markdown","bubble-demo-variant","bubble-demo-shape","bubble-demo-list","bubble-demo-bubble-custom","bubble-demo-list-custom","bubble-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/components/bubble/index.zh-CN.md?type=demo')
};